import React, { Component } from 'react';

import { Link } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { withRouter } from 'react-router-dom';

import './Search.css';
import '../config.js';

const restServer = global.restServer;

class Search extends Component {
    constructor(props){
        super(props);
        this.state = {
            idValue: '', 
            seqValue:'',
            props: props,
            isFetching : false,
            data: []
        };

        this.changeId = this.changeId.bind(this);
        this.submit4IdSearch = this.submit4IdSearch.bind(this);
        this.changeSeq = this.changeSeq.bind(this);
        this.submit4SeqSearch = this.submit4SeqSearch.bind(this);
   
    }

    componentDidMount() {
        let query = this.props.location.search;
        const url = [[restServer, 'search'].join("/"), encodeURI(query)].join('');
        this.setState({isFetching : true});

        fetch(url)
        .then(response => response.json())
        .then(data => this.setState({data: data, isFetching: false}));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            let query = nextProps.location.search;
            const url = [[restServer, 'search'].join("/"), encodeURI(query)].join(''); 
            this.setState({isFetching : true});
            fetch(url)
            .then(response => response.json())
            .then(data => this.setState({data: data, isFetching: false}));
            }
       
    }
    
    submit4IdSearch(event) {
        event.preventDefault();
        const url = process.env.PUBLIC_URL + '/search?t=txt;q=' + this.state.idValue; 
        this.props.history.push(url);
    }

    submit4SeqSearch(event) {
        event.preventDefault();
        const url = process.env.PUBLIC_URL + '/search?t=txt;q=' + this.state.seqValue; 
        this.props.history.push(url);
    }

    changeId(event) {
        this.setState({idValue: event.target.value});
    }

    changeSeq(event) {
        this.setState({seqValue: event.target.value});
    }

    render(props) {
        //console.log(this.state);
        const results = this.state.data.results;
        const query = this.state.data.query;

        if (this.state.isFetching) {
            return(<div> Searching .. </div>)
        }
        
        if (!results) {
            return(<></>);
        }
      //  console.log(results);

        let search_results = [];
        let activeTab = '';


        const cf_items = results.filter( (r) => (r.type === 'fold'));
        if (cf_items.length) {
            activeTab = 'cf_tab';
            search_results.push({
                items: cf_items,
                label: 'Folds',
                tab: 'cf_tab'
            })
        }
     
        const sf_items = results.filter( (r) => (r.type === 'superfamily'));
        if (sf_items.length) {
            activeTab = 'sf_tab';
            search_results.push({
                items: sf_items,
                label: 'Superfamilies',
                tab: 'sf_tab'
            })
        }
     
        const fa_items = results.filter( (r) => (r.type === 'family'));
        if (fa_items.length) {
            activeTab = 'fa_tab';
            search_results.push({
                items: fa_items,
                label: 'Families',
                tab: 'fa_tab'
            })
        }
     
        const dm_items = results.filter( (r) => (r.type === 'domain'));
        if (dm_items.length) {
            activeTab = 'dm_tab';
            search_results.push({
                items: dm_items,
                label: 'Domains',
                tab: 'dm_tab'
            })
        }
       
        const rep_items = results.filter( (r) => (r.type === 'represented'));
        if (rep_items.length) {
            if (activeTab !== 'dm_tab'){
                activeTab = 'rep_tab';
            }
            search_results.push({
                items: rep_items,
                label: 'Represented',
                tab: 'rep_tab',
                groupby: 'member_chain'
            })
        }
         
       //console.log('set_actie:', activeTab);
       // console.log(search_results);

        return (
            <div>
                <div className="pane">
                    <div className="pane-title">Search SCOP</div>
                    <Tabs className="tabbed-search" defaultActiveKey="idsearch">
                        <Tab  eventKey="idsearch" title="Keyword and ID search">
                            <Form className="search-form" onSubmit={this.submit4IdSearch}>
                                <FormControl onChange={this.changeId} className="searchbox" type="text" placeholder="Enter free text, SCOP ID, PDB ID or UniProt ID" />
                                <button type="submit" className="go-button">Go</button>
                            </Form>
                        </Tab>
                        <Tab eventKey="seqseach" title="Sequence search" disabled>
                            <Form className="search-form" onSubmit={this.submit4SeqSearch}>
                                <FormControl onChange={this.changeSeq} as="textarea" type="text" rows="5" cols="10" placeholder="Enter protein sequence" className="mr-sm-2 searchbox" />
                                <button className="go-button" type="submit">Go</button>
                            </Form>
                        </Tab>
                    </Tabs>
                </div>
                <SearchResultTabs query={query} results={search_results} activeTab={activeTab} />
                
            </div>
        )
    }
}

function RepresentedSearchResults(props) {
    const results = props.results;
   // console.log(results);
    //const num = results.length;
    const member_code = props.query;
    let chains = results.reduce( function(obj, hit){
        let chain = hit['member_chain'];
        if (!obj.hasOwnProperty(chain)) {
            obj[chain] = [];
        }
        obj[chain].push(hit);
        return obj;
    }, {});
   
    //console.log(chains);

    return (
        <div>
            <div className="search-results-pane">
                {
                    Object.keys(chains).sort().map( (chain) => (
                        <div key={"rsr_"+chain} className="sres">
                        <div className="message"> No SCOP2 classification is available for {member_code + " " + chain} explicitly. This entry is
                        represented by following domains ... </div> 
                        <RepresentedResult qid={props.query + " " + chain} result={chains[chain]} /> 
                    </div>))
                }
            </div>
                    
        
        </div>
    )
}

function RepresentedResult(props) {
   // console.log(props);
    return(
        <div>
        { props.result.map( (item) => (
            <div key={"sr_"+item.id} className="termlink">
                <span className="scopid">{item.id}</span>  
                <Link to={`${process.env.PUBLIC_URL}/term/`+item.id}>
                        {item.pdb_code + " " + item.pdb_chain}
                </Link>
           </div>))
        }
        </div>
    )
}
class SearchResultTabs extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          activeTab: this.props.activeTab,
          query: this.props.query,
          results: this.props.results
        };
        this.handleSelect = this.handleSelect.bind(this)

    }

    handleSelect = (tab) => {
        this.setState({ activeTab: tab });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState ({
            activeTab: nextProps.activeTab,
            query: nextProps.query,
            results: nextProps.results
        });
    }

    render() {
        const results = this.state.results;
        return (
            <div className="pane">
                <div className="pane-title">Search results for <span className="search-query">{this.state.query}</span></div>
                <Tabs className="tabbed-search" activeKey={this.state.activeTab} onSelect={this.handleSelect} id="controlled-tab-example">
                {
                    results.map((child) => (
                        <Tab key={child.tab} eventKey={child.tab} title={child.label + " [ " + child.items.length + " ] "} className="myTab"> 
                        { child.groupby ?
                            <RepresentedSearchResults query={this.state.query} results={child.items}  /> :
                        
                            <SearchResults results={child.items}  />
                        }
                        </Tab>
                    ))
                }
                </Tabs>
            </div>
        )
    }
}


export default withRouter(Search, SearchResultTabs);

function SearchResults(props) {
    return (
            
        <div className="search-results-pane">
            {
                props.results.map((item, index) => (
                    <div key={"sr_"+item.id} className="termlink">
                     <span className="scopid">{item.id}</span>    
                    <Link to={`${process.env.PUBLIC_URL}/term/`+item.id}>
                        {item.name}
                    </Link>
                    </div>
            
                ))
            }
         </div>
    )
}
